<template>
  <div id="basic">
    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <el-form-item label="请选择门店" style="margin-right: 20px">
          <el-select
            v-model="formInline.shop_id"
            placeholder="请选择"
            @change="getList"
          >
            <el-option
              v-for="index in typeDate"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="demo-form-inline">
          <el-form-item label="按启止时间" class="handInput">
            <el-date-picker
              v-model="formInline.date"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择"
              class="dateInput"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="状态" class="handInput">
            <el-select
              v-model="formInline.status"
              placeholder="请选择状态"
              class="headerInput"
            >
             <el-option
               
                label="不限制"
                value=""
              ></el-option>
              <el-option
                v-for="index in statusList"
                v-bind:key="index.id"
                :label="index.value"
                :value="index.key_name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付方式" class="handInput">
            <el-select
              v-model="formInline.pay_type"
              placeholder="请选择状态"
              class="headerInput"
            >
              <el-option
               
                label="不限制"
                value=""
              ></el-option>
              <el-option
                v-for="index in pay_typeList"
                v-bind:key="index.id"
                :label="index.label"
                :value="index.value"
              ></el-option>
            <el-option
               
                label="结算二维码"
                value="bridge"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="订单类型">
            <el-select placeholder="请选择" v-model="formInline.order_type">
            <el-option label="不限制" value=""></el-option>
          <el-option label="堂食" value="eatin"></el-option>
            <el-option label="移动管理端" value="bridge"></el-option>
          
          </el-select>

          </el-form-item>
          <el-form-item label="商品名称" class="handInput">
            <el-input
              v-model="formInline.name"
              class="headerInput"
              placeholder="请输入商品名称"
              type="number"
            ></el-input>
          </el-form-item>


          <el-form-item label="餐盘编号" class="handInput">
            <el-input
              v-model="formInline.plate_no"
              class="headerInput"
              placeholder="请输入餐盘编号"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" class="handInput">
            <el-input
              v-model="formInline.mobile"
              class="headerInput"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-button type="primary" style="background: #1890ff" @click="getList"
            >查询</el-button
          >
          <el-button
            type="primary"
            class="vubutton"
            @click="onSubmit"
          >重置</el-button>

            <download-excel
              :fetch="fetchData"
              :fields="json_fields"
              :before-generate="startDownload"
              name="订单列表.xls"
              style="display: inline-block; margin-left: 10px"
            >
              <el-button
                type="primary"
                :loading="upload"
                style="
                  background: #1baeae;
                  color: #fff;
                  border: none;
                  height: 40px;
                "
                >导出</el-button
              >
            </download-excel>
        </div>
        <!-- <div>
          <div>
            <p>总订单数</p>
          <p>33</p>
          </div>
          <div>
            <p>总订单数</p>
          <p>44</p>
          </div>
        </div> -->
        <el-row :gutter="10">
          <el-col :span="3">
            <div class="top-title">总订单数</div>
            <div class="top-numnber">{{ tabPage.count }}</div>
          </el-col>
          <el-col :span="3">
            <div class="top-title">合计金额</div>
            <div class="top-numnber">{{ tabPage.total_amount / 100 }}</div>
          </el-col>
        </el-row>

        <!-- <div class="bottom_center"> -->
        <!-- <el-form-item style="min-width: 150px;"> -->

        <!-- </el-form-item> -->
        <!-- </div> -->
      </el-form>

      <el-table :fit="false" border class="table" :data="tableData">
        <template slot="empty">
          <noCart></noCart>
        </template>

        <el-table-column label="订单编号" width="180" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单时间" width="180" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>

        <el-table-column label="商品名称" width="180" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

         <el-table-column label="订单类型"  align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.order_type | orderTypeString }}</span>
          </template>
        </el-table-column>


        
        <el-table-column label="用户名" width="180" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.client_nick_name }}</span>
          </template> 
        </el-table-column>
        <el-table-column label="手机号" width="140" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center" width="120">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status == '已支付' ? 'success' : 'danger'"
              >{{ scope.row.status | payStateString }}</el-tag
            >
            <!-- <span>{{ scope.row.status }}</span> -->
          </template>
        </el-table-column>
        <el-table-column label="总金额" width="140" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.pay_price  }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" width="140" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.pay_type | paychannelString }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="所属门店" width="180" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.shop_name }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column label="微信支付金额" width="140" align="center">
          <template slot-scope="scope">
            <span>¥{{ scope.row.pay_price/100 }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="优惠券折扣金额" width="140" align="center">
          <template slot-scope="scope">
            <span>¥{{ scope.row.discount_price/100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="余额支付金额" width="140" align="center">
          <template slot-scope="scope">
            <span>¥{{ scope.row.prepay_price/100}}</span>
          </template>
        </el-table-column> -->

        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button :key="scope.id" @click="setdialogFormVisible(scope.row)"
              >查看明细
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @current-change="pageSize"
        background
        layout="prev, pager, next"
        :total="tabPage.count"
        :page-size="page_size"
      ></el-pagination>

      <el-dialog title="订单明细" :visible.sync="dialogFormVisible" width="80%">
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="top-orderdetil">订单编号：{{ thisOrderData.id }}</div>
            <div class="top-orderdetil">
              客户名称：{{ thisOrderData.client_nick_name }}
            </div>
          </el-col>
          <el-col :span="12">
            <div class="top-orderdetil">
              订单时间：{{ thisOrderData.created_at }}
            </div>
            <div class="top-orderdetil">
              合计金额：{{ thisOrderData.total_price / 100 }}
            </div>
          </el-col>
        </el-row>

        <el-table
          :data="form"
          border
          style="width: 100%; margin-top: 30px"
          :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
        >
          <el-table-column label="取餐时间" width="180" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.created_at | datetime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="device_name" label="所属餐炉" width="120">
          </el-table-column>

          <el-table-column prop="dish_name" label="菜品名称" width="150">
          </el-table-column>

          <!-- <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status == '已支付' ? 'success' : 'danger'"
                >{{ scope.row.status }}</el-tag
              >
            </template>
          </el-table-column> -->
          <el-table-column label="菜品规格" align="center">
            <template slot-scope="scope">
              {{ scope.row.unit_price / 100 }}元-{{ scope.row.unit_amount }}/{{
                scope.row.dish_unit_name
              }}
            </template>
          </el-table-column>

          <el-table-column label="取餐分量" align="center">
            <template slot-scope="scope">
              {{ scope.row.total_amount }}{{ scope.row.dish_unit_name }}
            </template>
          </el-table-column>

          <el-table-column label="单项金额" align="center">
            <template slot-scope="scope">
              {{ scope.row.total_price / 100 }}元
            </template>
          </el-table-column>
        </el-table>
        <div class="foldtitle">膳食营养数据</div>
        <div class="foldMabox">
          <el-row :gutter="10">
            <el-col :span="12">
              <div class="leftBox">
                <div class="itemList">
                  <span class="itemTitle"> 蛋白质 </span>
                  <span class="itemNumber">
                    {{ formNutrition.protein }}克
                  </span>
                </div>
                <!-- formNutrition -->
                <div class="itemList">
                  <span class="itemTitle"> 脂肪 </span>
                  <span class="itemNumber"> {{ formNutrition.fat }}克 </span>
                </div>
                <div class="itemList">
                  <span class="itemTitle"> 碳水化合物 </span>
                  <span class="itemNumber">
                    {{ formNutrition.carbohydrate }}克
                  </span>
                </div>
                <div class="itemList">
                  <span class="itemTitle"> 油 </span>
                  <span class="itemNumber"> {{ formNutrition.oil }}克</span>
                </div>
                <div class="itemList">
                  <span class="itemTitle"> 盐 </span>
                  <span class="itemNumber"> {{ formNutrition.salt }}克</span>
                </div>
                <div class="itemList">
                  <span class="itemTitle"> 糖 </span>
                  <span class="itemNumber"> {{ formNutrition.sugar }}克 </span>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="rightBox">
                <div id="echart_AB" style="width: 100%; height: 300px"></div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="noStatus()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date';

export default {
  name: 'employee',
  data() {
    return {
      typeDate: [],
      formInline: {
        
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      statusList: [],
       json_fields: {
          门店: 'shop_name',
        门店id: 'shop_id',
        ID: 'id',
         订单时间: 'created_at',
       
        商品名称: 'name',
           用户名: 'client_nick_name',
             手机号: 'mobile',
            状态: 'status',
        总金额: 'pay_price', //如果命名的标题有空格,需要用双引号
        支付方式: 'pay_type',
         订单类型: 'order_type',
         
          
        
      },
      pay_typeList: [
        {
          id: 1,
          value: 'alipay',
          label: '支付宝',
        },
        {
          id: 2,
          value: 'wechat',
          label: '微信',
        },
        {
          id: 3,
          value: 'tianfutong',
          label: '天府通',
        },
        {
          id: 4,
          value: 'prepay',
          label: '预支付',
        },
        {
          id: 5,
          value: 'magcard',
          label: 'IC卡',
        },
      ],
      tableData: [],
      dialogFormVisible: false,
      form: [],
      formNutrition: {},
      formLabelWidth: '200px',
      tabPage: {
        count: 0,
        total_amount: 0,
      },
      upload: false,
      thisOrderData: {},
      page_size: 20,
      page_no: 1,
    };
  },
  methods: {
     startDownload() {
      this.upload = true;
      // alert('show loading');
     
    },
    async fetchData() {
      const shopValue = this.typeDate.find(
        (item) => item.id === this.formInline.shop_id
      );
    if(!this.formInline.date || !this.formInline.date[0] || !this.formInline.date[1]){
       this.$alert('请选择时间')
       this.upload = false;
      return;
    }
     let statedate=new Date(this.formInline.date[0]),enddate=new Date(this.formInline.date[1]);
     if((enddate.getTime() - statedate.getTime()) > 7776000000){
        this.$alert('仅支持导出3个月订单');
        this.upload = false;
       return
     }
       console.log( '更新：',this.formInline.date);
     
      const url = this.$userList.user_order_search;
      const data = {
        shop_id: shopValue.id,
        plate_no: this.formInline.plate_no || '',
        mobile: this.formInline.mobile,
        pay_type: this.formInline.pay_type,
        order_type:this.formInline.order_type,
        name:this.formInline.name,
        status: this.formInline.status || '',
        // start_date: (this.formInline.date && this.formInline.date[0]) || '',
        // end_date: (this.formInline.date && this.formInline.date[1]) || '',
        page_index: 1,
        page_size: this.tabPage.count,
      };
       if(this.formInline && this.formInline.date && this.formInline.date.length>0){
            data.start_date=fecha.format(
              new Date(this.formInline.date[0]),
              'yyyy-MM-dd HH:mm:ss'
            )
              data.end_date=fecha.format(
              new Date(this.formInline.date[1]),
              'yyyy-MM-dd HH:mm:ss'
            )
        }
    
      let tableData=[] || []
       let res= await this.$http.post(url, data);
       console.log("🚀 ~ file: index.vue:475 ~ fetchData ~ res:", res)
       
        tableData = res.data.items || [];
        tableData.forEach((item)=>{
          item.pay_price=item.pay_price / 100;
          if(item.pay_type=='BRIDGE'){
              item.pay_type='结算二维码支付'
          }
            if(item.pay_type=='member'){
              item.pay_type='会员支付'
          }
          if(item.order_type=='bridge'){
              item.order_type='移动管理端'
          }
          item.updated_at = fecha.format(
              new Date(item.updated_at),
              'yyyy-MM-dd HH:mm:ss'
            );
          item.created_at = fecha.format(
              new Date(item.created_at),
              'yyyy-MM-dd HH:mm:ss'
            );
        })
        this.tableData = res.data.items;
           console.log('跟新：',tableData);
          this.tabPage = res.data;
           this.upload = false;
       
       
        return tableData;

    },
    pageSize(index) {
      this.page_no = index;
      this.getList();
    },
    noStatus() {
      this.dialogFormVisible = false;
    },
    setdialogFormVisible(orderData) {
      // console.log(id);
      const id = orderData.id;
      this.thisOrderData = orderData;
      const url = this.$userList.user_order_detail + `/` + id;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          let data = res.data;
          // (data.device_order_items || []).map((item) => {
          //   item.created_at = fecha.format(
          //     new Date(item.created_at),
          //     'yyyy-MM-dd HH:mm:ss'
          //   );
          //   item.updated_at = fecha.format(
          //     new Date(item.updated_at),
          //     'yyyy-MM-dd HH:mm:ss'
          //   );
          // dietary_nutrition
          // });

          this.form = data.device_order_items;
          // console.log(data);
          this.formNutrition = data.dietary_nutrition || {};
          const { max_heat, max_weight, total_heat, total_weight } = data;
          this.formNutrition.max_heat = max_heat;
          this.formNutrition.max_weight = max_weight;
          this.formNutrition.total_heat = total_heat;
          this.formNutrition.total_weight = total_weight;

          this.dialogFormVisible = true;
          setTimeout(() => {
            //DOM渲染阶段
            this.fooddetil(this.formNutrition);
          }, 400);

          //        option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0;
          // myChart.setOption(option, true);
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    fooddetil(
      eatData = { max_heat: 100, total_heat: 0, total_weight: 0, max_weight: 0 }
    ) {
      let elementById = document.getElementById('echart_AB');
      let echartsDemo = this.$echarts.init(elementById);
      let option = {
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%',
        },
        toolbox: {
          show: false,
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        series: [
          {
            name: '膳食热量',
            type: 'gauge',
            center: ['25%', '55%'], // 默认全局居中
            min: 0,
            max: eatData.max_heat,
            title: {
              fontWeight: 'bold',
              offsetCenter: [0, 80], // x, y，单位px
            },
            axisLine: {
              lineStyle: {
                width: 24,
              },
            },
            axisLabel: {
              distance: 0,
              fontSize: 10,
            },
            detail: { formatter: '{value}C' },
            data: [{ value: eatData.total_heat, name: '膳食热量' }],
          },
          {
            name: '取餐分量',
            type: 'gauge',
            center: ['75%', '55%'], // 默认全局居中
            min: 0,
            max: eatData.max_weight,
            title: {
              fontWeight: 'bold',
              offsetCenter: [0, 80], // x, y，单位px
            },
            axisLine: {
              lineStyle: {
                width: 24,
              },
            },
            axisLabel: {
              distance: 0,
              fontSize: 10,
            },
            detail: { formatter: '{value}克' },
            data: [{ value: eatData.total_weight, name: '取餐分量' }],
          },
        ],
      };

      echartsDemo.setOption(option);
    },
    onSubmit() {
      console.log('submit!');
      const shop_id = this.formInline.shop_id;
      this.formInline = {
        shop_id,
      };
      this.getList();
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.shop_id = res.data.items[0].id;
          this.getList();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //通用状态
    getCommonData() {
      const url = this.$userList.user_common_data + `/order_status`;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          console.log(res.data);
          this.statusList = res.data;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    getList() {
      const shopValue = this.typeDate.find(
        (item) => item.id === this.formInline.shop_id
      );
      console.log(shopValue);
      const url = this.$userList.user_order_search;
      const data = {
        shop_id: shopValue.id,
        plate_no: this.formInline.plate_no || '',
        mobile: this.formInline.mobile,
        pay_type: this.formInline.pay_type,
        status: this.formInline.status || '',
        order_type:this.formInline.order_type,
         name:this.formInline.name,
        // start_date: (this.formInline.date && this.formInline.date[0]) || '',
        // end_date: (this.formInline.date && this.formInline.date[1]) || '',
        page_index: this.page_no,
        page_size: this.page_size,
      };
       if(this.formInline && this.formInline.date && this.formInline.date.length>0){
            data.start_date=fecha.format(
              new Date(this.formInline.date[0]),
              'yyyy-MM-dd HH:mm:ss'
            )
              data.end_date=fecha.format(
              new Date(this.formInline.date[1]),
              'yyyy-MM-dd HH:mm:ss'
            )
        }
      console.log(data);
      this.$http.post(url, data).then((res) => {
        if (res.code === 200) {
           let   tableData = res.data.items || [];
        tableData.forEach((item)=>{
          item.pay_price=item.pay_price / 100;
         
         
          item.updated_at = fecha.format(
              new Date(item.updated_at),
              'yyyy-MM-dd HH:mm:ss'
            );
          item.created_at = fecha.format(
              new Date(item.created_at),
              'yyyy-MM-dd HH:mm:ss'
            );
        })
        this.tableData = tableData;
          
      
          // this.total = res.data.count;
          this.tabPage = res.data;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
  },
  created() {
    this.$root.setheadName();
    this.getType();
    this.getCommonData();
    setTimeout(() => {
      this.fooddetil();
    }, 400);

    // this.rows();
    // this.getMuList();
  },
};
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
  font-size: 14px;
}
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}

.top_div {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}

.demo-form-inline {
  display: block;
  margin-bottom: 10px;
  /* display: flex;
  justify-content: flex-start; */
}
.dateInput {
  width: 400px;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  line-height: 32px;
}
.headerInput {
  width: 200px;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  line-height: 32px;
}

/* .el-select > .el-input,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
}

.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}

.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}

.bottom_center {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.top-orderdetil {
  padding-left: 10%;
  font-size: 14px;
  line-height: 30px;
}
.foldtitle {
  background-color: #eef1f6;
  text-align: center;
  font-size: 14px;
  line-height: 23px;
  padding: 12px;
  font-weight: 700;
  color: #909399;
  margin-top: 30px;
}
.foldMabox {
  border: 1px solid #eef1f6;
}
.leftBox {
  // border-right: 1px solid #eef1f6;
  .itemList {
    width: 100%;
    line-height: 40px;
    border-top: 1px solid #eeeeee;
    color: #333333;
    font-size: 14px;
    .itemTitle {
      width: 40%;
      display: inline-block;
      padding-left: 10%;
      font-weight: 600;
    }
    .itemNumber {
      width: 40%;
      display: inline-block;
      padding-left: 10%;
    }
  }
}
.rightBox {
  border-top: 1px solid #eeeeee;
  border-left: 1px solid #eeeeee;
}

.top-title {
  font-weight: 400;
  color: #606266;
  font-size: 14px;
}
.top-numnber {
  font-weight: 700;
  line-height: 40px;
  font-size: 23px;
}
.handInput {
  margin-right: 20px !important;
}
</style>
